import { SMSIcon } from '@rsos/assets/icons';
import { FeedbackButton } from '@rsos/components/capstone/FeedbackButton';
import { GISFeedbackButtonContainer } from './styles';

export function GISFeedbackButton() {
  return (
    <FeedbackButton>
      <GISFeedbackButtonContainer title="Give Feedback" tabIndex={0}>
        <SMSIcon width={16} height={16} color="primaryText" />
      </GISFeedbackButtonContainer>
    </FeedbackButton>
  );
}
